/* eslint-disable import/prefer-default-export */
import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

/**
 * Retrieve learning chapters
 * @param {string} student
 * @param {string} version
 */
export const getLearningChapterList = ({ student, version = 'v2' } = {}) =>
  client
    .request({
      url: `${version}/learning/chapters/`,
      method: RequestMethod.GET,
      params: {
        student,
        limit: 40,
      },
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Retrieve learning chapter
 * @param {string} chapterUuid
 */
export const getLearningChapter = ({ chapterUuid, version = 'v2' } = {}) =>
  client
    .request({
      url: `${version}/learning/chapters/${chapterUuid}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Retrieve learning tasks
 * @param {string} chapterId
 * @param {string} userId
 * @param {string} version
 */
export const getLearningTaskList = ({ chapterId, student, version = 'v2' }) =>
  client
    .request({
      url: `${version}/learning/learning-tasks/`,
      method: RequestMethod.GET,
      params: {
        chapterUuid: chapterId,
        student,
      },
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Retrieve learning task
 * @param {string} chapterId
 * @param {string} student
 * @param {string} version
 */
export const getLearningTask = ({ taskId, student, version = 'v2' }) => {
  const counselorTaskRetrievalUrl =
    student === 'preview'
      ? `learning/learning_task/${taskId}/`
      : `learning/learning_task/${taskId}/user/?student=${student}`;

  const studentTaskRetrievalUrl = `learning/learning_task/${taskId}/user/`;

  const url = student ? counselorTaskRetrievalUrl : studentTaskRetrievalUrl;

  return client
    .request({
      url: `${version}/${url}`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
};

/**
 * Marking link as viewed
 * @param student
 * @param {string} uuid
 * @param {string} version
 */
export const markLinkAsViewed = ({ student, uuid, version = 'v2' }) =>
  client
    .request({
      url: `${version}/elements/link/${uuid}/user/click/`,
      method: RequestMethod.POST,
      params: { student },
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Marking video as started
 * @param student
 * @param {string} uuid
 * @param {string} version
 */
export const markVideoAsStarted = ({ student, uuid, version = 'v2' }) =>
  client
    .request({
      url: `${version}/elements/video/${uuid}/user/start/`,
      method: RequestMethod.POST,
      params: { student },
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Marking video as watched
 * @param student
 * @param {string} uuid
 * @param {string} version
 */
export const markVideoAsWatched = ({ student, uuid, version = 'v2' }) =>
  client
    .request({
      url: `${version}/elements/video/${uuid}/user/end/`,
      method: RequestMethod.POST,
      params: { student },
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Send quiz answer
 * @param {string} uuid
 * @param {string} questionId
 * @param {number} student
 * @param {string} answer
 * @param {string} version
 */
export const sendQuizResponse = ({
  uuid,
  questionId,
  student,
  answer,
  version = 'v2',
}) =>
  client
    .request({
      url: `${version}/quiz/quiz/${uuid}/user/question/${questionId}/`,
      method: RequestMethod.POST,
      data: {
        answer,
      },
      params: { student },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getLearningTaskChaptersList = ({ version = 'v2' }) =>
  client
    .request({
      url: `${version}/learning/learning-tasks/chapters/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
